import { ReactFlowProvider } from '@xyflow/react';
import { WorkflowChain } from './components/WorkflowChain';
import { Toaster } from './components/Toaster';
import { AddWorkflowButton } from './components/AddWorkflowButton';
import { ReviewModal } from './components/ReviewModal';
import { OAuthPanel } from './components/OAuthPanel';
import { StreamPollerEffect } from './lib/poller';

export default function App() {
  return (
    <ReactFlowProvider>
      <StreamPollerEffect />
      <div className="min-h-dvh flex flex-col">
        <header className="px-6 py-4 flex items-center justify-between gap-4 border-b border-ink-900">
          <div className="flex items-baseline gap-3">
            <h1 className="text-sm font-semibold tracking-wide text-ink-100">clipfarm</h1>
            <span className="text-[11px] text-ink-500 lowercase">autonomous clip → edit → publish</span>
          </div>
          <OAuthPanel />
        </header>

        <Toaster />

        <main className="flex-1 relative">
          <WorkflowChain />
        </main>

        <footer className="px-6 py-4 flex items-center justify-center border-t border-ink-900">
          <AddWorkflowButton />
        </footer>

        <ReviewModal />
      </div>
    </ReactFlowProvider>
  );
}
